var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1721 8.70389C1.41368 7.38145 1.04748 6.30158 0.82667 5.20697C0.500098 3.58806 1.24745 2.00665 2.4855 0.997579C3.00876 0.571106 3.60858 0.716814 3.918 1.27192L4.61655 2.52513C5.17023 3.51845 5.44707 4.01512 5.39216 4.54167C5.33725 5.06823 4.96389 5.49709 4.21718 6.35481L2.1721 8.70389ZM2.1721 8.70389C3.7072 11.3806 6.11627 13.791 8.79611 15.3279M8.79611 15.3279C10.1186 16.0863 11.1984 16.4525 12.293 16.6733C13.9119 16.9999 15.4934 16.2526 16.5024 15.0145C16.9289 14.4912 16.7832 13.8914 16.2281 13.582L14.9749 12.8835C13.9815 12.3298 13.4849 12.0529 12.9583 12.1078C12.4318 12.1627 12.0029 12.5361 11.1452 13.2828L8.79611 15.3279Z",
    stroke: "#0CAB47",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorPhone);
export default __webpack_public_path__ + "static/media/distributorPhone.2c6f23ef07c71e8768ec42a1728d1672.svg";
export { ForwardRef as ReactComponent };